function CartItem(item) {
  this.id = item.id;
  this.date = null;
  // considero tudo extra, incluido o nº de pessoas e o horario
  this.extras = _.keyBy(item.extras, "id");
  this.total = 0;
  this.onupdate = function() {};
  this.onChangeState = function() {};
  this.active = false;
  this.name = item.name;
  this.winerie_name = item.winerie.name;
  this.type = item.type;
  this.booking_url = item.booking_url;

  var vm = this;

  $("[name^='xp:" + this.id + "']").change(function() {
    var $input = $(this);
    var name = $input.attr("name");
    var { extra } = _.chain($(this).attr("name"))
      .split("#")
      .map((i) => i.split(":"))
      .fromPairs()
      .value();

    var value = $input.val();
    if (vm.extras[extra].type.id == 1) {
      value = $input.is(":checked") ? 1 : 0;
    }
    vm.extras[extra].value = value;
    //    console.log($input, name, value);
    vm.onupdate(vm.id);
  });

  this.computeItemTotal = function() {
    var extras = this.extras;
    var xp_total = 0;
    var discountCode = TXAPP.DISCOUNT.codeData || {};

    for (const key in extras) {
      var extra = extras[key];
      // var $input = $('[name="xp:' + this.id + '#extra:' + extra.id + '"]');
      var value = parseInt(extra.value) || 0;
      var price = extra.price || 0;

      switch (extra.type.id) {
        case "1":
        case "3":
        case "4":
          price = price * (parseInt(value) || 0);
          break;

        case "2":
          // for (var i = 0; i < extra.children.length; i++) {
          //   console.log(extra.children[i], value);
          //   if (
          //     extra.children[i].content_id == value &&
          //     extra.children[i].price
          //   ) {
          //     price = extra.children[i].price;
          //   }
          // }
          var children_has_price = extra.children.some((v) => v.price > 0);
          if (children_has_price) {
            var opt = (extra.children || []).find((c) => c.content_id == value);
            if (opt) {
              price = opt.price;
            }
          } else {
            price = price * (!!value ? 1 : 0);
          }
          break;
      }

      if (extra.per_person == "1") {
        var person_count =
          parseInt($('[name="xp:' + this.id + '#extra:person"]').val() || 0) +
          parseInt($('[name="xp:' + this.id + '#extra:children"]').val() || 0);
        // console.log('person_count', person_count);
        price = price * person_count;
      }

      // console.log($input.attr('name'), value, price);
      xp_total = xp_total + parseFloat(price);
    }

    if (discountCode && discountCode.redution_type == 1) {
      xp_total =
        xp_total * ((100 - parseFloat(discountCode.reduction_value)) / 100);
    } else if (discountCode && discountCode.redution_type == 2) {
      xp_total = xp_total - parseFloat(discountCode.reduction_value);
    }

    this.total = xp_total < 0 ? 0 : xp_total;
    return xp_total;
  };

  this.setupFromStore = function(obj) {
    if (_.isEmpty(obj)) {
      return;
    }
    console.log("setup from store ", obj.id, obj.date);
    //$('#xp-date').val(obj.date);
    $(".booking-input-date[data-id=" + obj.id + "]").val(obj.date);
    this.date = obj.date;
    this.changeExperienceState(obj.active);
    for (const key in obj.extras) {
      if (obj.extras[key].value !== undefined) {
        $("[name='xp:" + this.id + "#extra:" + key + "']").val(
          obj.extras[key].value,
          this.extras[key].value
        );
        this.extras[key].value = obj.extras[key].value;
      }
    }
  };

  this.changeExperienceState = function(state) {
    this.active = state;
    if (state) {
      $(".add_xp_" + this.id).hide();
      //$('.added_xp_' + this.id).show();
    } else {
      $(".add_xp_" + this.id).show();
      $(".added_xp_" + this.id).hide();
    }
    this.onChangeState();
  };

  this.personCount = function() {
    return (
      parseInt(_.get(this.extras, "person.value", 0)) +
      parseInt(_.get(this.extras, "children.value", 0))
    );
  };
}
